import React, { ChangeEvent } from 'react';
import { Box, Typography } from '@material-ui/core';
import { Lock } from '@material-ui/icons';
import { SessionItem } from './SessionItem';
import { AvailabilityCenterSession } from './__generated__/AvailabilityCenterSession';

interface Props {
  sessions: AvailabilityCenterSession[];
  selectedSessionIds: string[];
  onSelectSession: (sessionIds: string[]) => void;
  currentDate?: string;
}

export function SessionSelect({ sessions, selectedSessionIds, onSelectSession, currentDate }: Props) {
  const handleSelectSession = (event: ChangeEvent<HTMLInputElement>) => {
    const sessionId = event.target.name;
    if (selectedSessionIds.includes(sessionId)) {
      onSelectSession(selectedSessionIds.filter((curentSessionId) => curentSessionId !== sessionId));
    } else {
      onSelectSession(selectedSessionIds.concat(sessionId));
    }
  };

  if (sessions.length === 0) {
    return (
      <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' py={6}>
        <Lock style={{ fontSize: 40, color: '#BDBDBD', marginBottom: 12 }} />
        <Typography style={{ fontSize: 15, fontWeight: 600, color: '#757575' }}>No sessions available</Typography>
        <Typography style={{ fontSize: 13, color: '#9E9E9E', marginTop: 4, textAlign: 'center' }}>
          This activity has role-restricted sessions that don&apos;t match your current roles.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      {sessions.map((session) => (
        <SessionItem
          key={session.sessionId}
          session={session}
          isSelected={selectedSessionIds.includes(session.sessionId)}
          onSelect={handleSelectSession}
          currentDate={currentDate}
        />
      ))}
    </>
  );
}
